<template>
<div class="login">

    <div class="body">
        <div class="wrapper fadeInDown">
            <!-- Form -->
          <form id="formContent" @submit="login">
                 <!--Tabs Titles -->

                <!--Icon -->
                <div class="fadeIn first">
                    <h2>{{msg}}</h2>
                </div>

                <div class="alert alert-warning text-center" id="warning-alert">
                    <button type="button" class="close" data-dismiss="alert">x</button>
                    <strong>Error! </strong> {{msg_alert}}
                </div>

                <!--Login Form -->
                <div class="pt-3">

                    <input type="email" id="password1" class="fadeIn third" name="login"
                    placeholder="Correo Electrónico" v-model="email" required>
                    <input type="password" id="password2" class="fadeIn third" name="login"
                    placeholder="Contraseña" v-model="pass" required>
                    <div class="pt-2">

                      <!--<router-link class="fadeIn fourth botonEntrar" to="Perfil">{{btnMsg}}</router-link>-->
                       <button class="fadeIn fourth botonEntrar"> {{btnMsg}} </button>
                    </div>
                </div>

                 <!--Remind Passowrd -->
                <div id="formFooter">

                  <div v-if="showFooterInicioSesion">
                    <router-link to="Recuperacion" >¿Has olvidado la contraseña?</router-link>
                    <p>¿No tienes una cuenta?
                      <router-link to="Registro">Regístrate</router-link>
                    </p>
                  </div>

                  <div v-if="showFooterRegistro">
                    <small> Al registrarte, aceptas nuestras <a class="underlineHover" href="#"> Condiciones de uso </a> y <a class="underlineHover" href="#"> Política de privacidad. </a></small>
                    <p>¿Ya tienes cuenta?
                      <router-link to="Login" @click="tipoRegistro = 0">Iniciar sesíon</router-link>
                    </p>
                  </div>

                </div>

            </form>

        </div>

    </div>

</div>
</template>



<script>
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
  name: 'Login',
  props:['tipoRegistro', 'tipo'],
  mounted:function(){

    $("#warning-alert").hide();

    if(this.tipoRegistro==1)
    {
      this.msg = '¡Inscríbete y comienza a buscar oportunidades!';
      this.btnMsg = 'Regístrate';
      this.showInputNombre =  true;
      this.showFooterInicioSesion= false;
      this.showFooterRegistro= true;
      this.opcionRegistro = this.tipo;
    }
  },
  data () {
    return {
      msg: '¡Inicia sesión en tu cuenta de itSAPp!',
      btnMsg: 'Entrar',
      showInputNombre: false,
      showFooterInicioSesion: true,
      showFooterRegistro: false,
      name: '',
      apellido: '',
      pass: '1234',
      pass2: '',
      email: '',
      msg_alert: '',
      opcionRegistro: 0,
      sesion: false
    }
  },
  methods:{

    login(e)
    {
      e.preventDefault();

      let dataInicio = {
          email: this.email,
          pass: this.pass,
          token: ''
        }

      if(this.opcionRegistro == 0){//login
        this.alert = false;
        //console.log('login_login');

        let data = {
          email: this.email,
          pass: this.pass,
          token: ''
        }

        this.inicioSesion(dataInicio);
      }
    },

    _getSuscription() {

        let data = {};
        let url = this.urlApi + '/date/'+ localStorage.userID;
        //console.log(url);
        this.axios
            .put(url, data)
            .then(response => {
              this.$router.push('perfil');
            })
            .catch(e => {
            }
        );

    },

    inicioSesion(data){

      this.axios.post(this.url+'sesion.php', data).then((responce) =>{
          //console.log('responce login', responce.data);

          if(responce.data.res == 200){

            localStorage.token = responce.data.token; //atrapamos el token,id y rol desde el servidor y su nombre
            localStorage.userID = responce.data.userID;
            localStorage.rol = responce.data.rol;
            localStorage.tabla = responce.data.tabla;

            if(localStorage.rol == '0' || localStorage.rol == '1'){
              this._getSuscription();
            }else{
              this.$router.push('admin');
            }

          }else{
            this.msg_alert = 'Verifica tu usuario y/o contraseña';
            $("#warning-alert").fadeTo(5000, 500).slideUp(500, function() {
              $("#success-alert").slideUp(500);
            });
          }
        })
    }

  },
  computed:{
    ...mapState(['url', 'urlApi', 'publishKey'])
  },
}
</script>

<style scoped>

a {
  color: #92badd;
  display:inline-block;
  text-decoration: none;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  display:inline-block;
  margin: 40px 8px 10px 8px;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

.wrapperH {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* FORM TYPOGRAPHY*/

.botonEntrar{
  background-color: #ff573b;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}
input[type=text]{
   background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  margin: 0px 0px 0px 35px;
  font-size: 16px;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type=password], input[type=email] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus, input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #ff573b;;
}

input[type=text]:placeholder, input[type=password]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after{
  width: 100%;
}

/* OTHERS */

*:focus {
    outline: none;
}

#icon {
  width:60%;
}


</style>>




// WEBPACK FOOTER //
// src/views/Login/Login.vue